export enum SortingDirection {
    none = 0,
    asc = 1,
    desc = 2,
}
